import React, {useContext, useMemo} from "react";
import {DataGridStateContext} from "../../../../index";
import DataGridBodyRow from "../row";
import classnames from "classnames";

/**
 * @param {DataGridInternalRow} row
 * @param {boolean} visible
 * @param {Function} startScrolling
 * @param {boolean} alternateColor
 * @return {JSX.Element}
 * @constructor
 */
const DataGridBodyGroupedRows = ({row, visible, startScrolling, alternateColor = true}) => {
    const {density} = useContext(DataGridStateContext);
    const rows = useMemo(() => row.groupedRows, [row?.groupedRows])

    return (
        <>
            {
                visible &&
                rows.map(row => (
                    <DataGridBodyRow
                        key={row.key}
                        density={density}
                        row={row}
                        className={classnames({'data-grid-grouped-row': alternateColor})}
                        startScrolling={startScrolling}
                    />
                ))
            }
        </>
    )
}

export default DataGridBodyGroupedRows;
